import {FC} from 'react'
import FromBarcodesModule from '../../modules/offers/match-by-barcode/FromBarcodesPage'

const FromBarcodesPage: FC = () => <FromBarcodesModule />

export default FromBarcodesPage
